import { lazy } from 'react';

/**
 * Wraps React.lazy so that a failed dynamic import — which almost always means
 * a stale chunk reference after a NEW DEPLOYMENT (the old chunk file no longer
 * exists on the server) — triggers a single full-page reload to fetch the fresh
 * index.html + chunk manifest, instead of dropping the user on the error screen.
 *
 * Guarded to reload at most once per 10s window so a genuinely broken build
 * can't cause an infinite reload loop (it falls through to the ErrorBoundary).
 */
export function lazyWithRetry(importer) {
  return lazy(async () => {
    try {
      return await importer();
    } catch (error) {
      const KEY = 'chunkReloadAt';
      const last = Number(sessionStorage.getItem(KEY)) || 0;
      if (Date.now() - last > 10000) {
        sessionStorage.setItem(KEY, String(Date.now()));
        window.location.reload();
        // Never resolve: keep the Suspense fallback up until the reload happens,
        // so nothing renders (and no error is thrown) in the meantime.
        return new Promise(() => {});
      }
      throw error;
    }
  });
}

export default lazyWithRetry;
